export class Dentista {
  cpf: string;
  cro: string;
  uf: string;
  qtdCupons: number;
}
